












































import mixins from 'vue-typed-mixins';
import { DataTableHeader, DataTableCompareFunction } from 'vuetify';
import SurveyUtils, { Survey, SurveyState } from '@/utils/SurveyUtils';
import SurveyStateForm from '@/components/survey/management/SurveyStateForm.vue';
import cloneDeep from 'lodash.clonedeep';
export default mixins().extend({
  components: {
    SurveyStateForm,
  },
  props: {
    value: {
      type: Object as () => Survey,
    },
  },
  computed: {
    headers(): DataTableHeader<SurveyState>[] {
      return [
        { text: this.$i18n.tc('model.common.key'), value: 'key' },
        {
          text: this.$i18n.tc('model.surveyState.category'),
          value: 'category',
        },
        {
          text: this.$i18n.tc('model.surveyState.nextstate.serviceprovider'),
          value: 'nextstate.serviceprovider.name',
        },
        {
          text: this.$i18n.tc('model.surveyState.nextstate.oversight'),
          value: 'nextstate.oversight.name',
        },
      ];
    },
  },
  data(): {
    states?: SurveyState[];
    state?: Partial<SurveyState>;
    visible: boolean;
  } {
    return {
      states: undefined,
      state: undefined,
      visible: false,
    };
  },
  async mounted() {
    try {
      this.states = await SurveyUtils.api.surveyState.list({
        surveyid: this.value.id as number,
      });
    } catch (error) {
      this.$alert.show('remove', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },
  methods: {
    async create() {
      this.state = {
        key: undefined,
        survey: { id: this.value.id },
        category: undefined,
        name: this.$languageobj(),
        label: this.$languageobj(),
        editablebysp: false,
        editablebyoversight: false,
        nextstate: {
          serviceprovider: [],
          oversight: [],
        },
      };
      this.visible = true;
    },
    async edit(state: SurveyState) {
      this.state = cloneDeep(state);
      this.visible = true;
    },
    async remove(state: SurveyState) {
      await this.$confirm(
        this.$i18n.t('validation.confirmation.delete', [state.key]).toString(),
        async () => {
          if (state.id && this.states) {
            this.$alert.hide('remove');
            await SurveyUtils.api.surveyState.remove(state.id);

            this.$toast.push({
              type: 'success',
              text: this.$languageobj('validation.success.delete', {
                values: [state.key],
              }),
            });

            const index = this.states.findIndex((val) => val.id === state.id);
            if (index >= 0) {
              this.states.splice(index, 1);
            }
          }
        }
      );
    },
    async submit() {
      try {
        if (this.state?.id) {
          this.$alert.hide('submit');
          await SurveyUtils.api.surveyState.update(this.state);
          if (this.states) {
            const index = this.states.findIndex(
              (val) => val.id === this.state?.id
            );
            if (index >= 0) {
              this.states[index] = this.state as SurveyState;
            }
          }
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.default', {
              values: [this.state?.key],
            }),
          });
        } else if (this.state) {
          this.state.id = await SurveyUtils.api.surveyState.add(
            this.state as SurveyState
          );
          this.states?.push(this.state as SurveyState);
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.add', {
              values: [this.state?.key],
            }),
          });
        }
        this.states = Array.from(this.states || []);
      } catch (error) {
        this.$alert.show('submit', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
      this.visible = false;
      this.state = undefined;
    },
    cancel() {
      this.visible = false;
      this.state = undefined;
    },
  },
});
